import React from "react";

const RotateBack = ({ size, color }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill={color}
      width={size}
      height={size}
      viewBox="0 0 24 24"
    >
      <path d="M11.919,4a.243.243,0,0,1-.172-.414l1.879-1.879A1,1,0,1,0,12.212.293l-4,4a1,1,0,0,0,0,1.416l4,4a1,1,0,1,0,1.414-1.414L11.747,6.414A.243.243,0,0,1,11.919,6a8,8,0,0,1,0,16,1,1,0,1,0,0,2,10,10,0,0,0,0-20Z" />
      <path d="M8.827,21.381A8.008,8.008,0,0,1,7.1,20.39a1,1,0,0,0-1.206,1.6,10.036,10.036,0,0,0,2.156,1.24,1,1,0,0,0,.773-1.845Z" />
      <path d="M4.063,15.523a1,1,0,1,0-1.963.382,10.079,10.079,0,0,0,.844,2.507,1,1,0,0,0,1.8-.883A7.961,7.961,0,0,1,4.063,15.523Z" />
      <path d="M4.438,8.891a1,1,0,0,0-1.352.415,10.019,10.019,0,0,0-.939,2.573A1,1,0,0,0,4.1,12.3a8.012,8.012,0,0,1,.752-2.062A1,1,0,0,0,4.438,8.891Z" />
    </svg>
  );
};

export default RotateBack;
